import store from '../../store/index'

let wsUrl = ''
let webSocket = null // 不挂载window，模块内部持有实例
let lockReconnect = false
let reconnectTimer = null

// 心跳对象
const heartCheck = {
  timeout: 50000, //50s发心跳
  severTimeout: 5000, //5s等待服务端心跳回复
  timeoutObj: null,
  serverTimeoutObj: null,
  start: function () {
    const _this = this
    // 清除旧心跳定时器
    this.timeoutObj && clearTimeout(this.timeoutObj)
    this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj)

    this.timeoutObj = setTimeout(function () {
      if (!webSocket || webSocket.readyState !== WebSocket.OPEN) return
      const data = { type: 10001 }
      webSocket.send(JSON.stringify(data))

      _this.serverTimeoutObj = setTimeout(function () {
        // 服务端心跳超时，主动关闭，触发onclose走重连
        webSocket && webSocket.close()
      }, _this.severTimeout)
    }, this.timeout)
  },
  // 停止心跳
  stop: function () {
    clearTimeout(this.timeoutObj)
    clearTimeout(this.serverTimeoutObj)
    this.timeoutObj = null
    this.serverTimeoutObj = null
  }
}

/**
 * 重连函数
 */
function reconnect(url) {
  if (lockReconnect) return
  lockReconnect = true
  // 清理旧重连定时器
  reconnectTimer && clearTimeout(reconnectTimer)

  reconnectTimer = setTimeout(() => {
    lockReconnect = false
    // 重连前关闭旧实例
    closeSocket()
    connectSocket(url)
  }, 4000)
}

/**
 * 关闭socket，清理所有定时器、心跳
 */
export function closeSocket() {
  heartCheck.stop()
  reconnectTimer && clearTimeout(reconnectTimer)
  lockReconnect = false

  if (webSocket) {
    // 移除事件监听，防止残留回调
    webSocket.onclose = null
    webSocket.onerror = null
    webSocket.onopen = null
    webSocket.onmessage = null
    if ([WebSocket.OPEN, WebSocket.CONNECTING].includes(webSocket.readyState)) {
      webSocket.close(1000, 'client manual close')
    }
    webSocket = null
  }
}

/**
 * 发送消息，递归增加最大重试次数，防止无限递归
 */
const sendWebSocket = (retryCount = 0) => {
  const MAX_RETRY = 8
  if (!webSocket) return

  if (webSocket.readyState === WebSocket.OPEN) {
    const token = store.state.userLoginMessage.token
    const data = { type: 10000, token: token }
    webSocket.send(JSON.stringify(data))
    heartCheck.start()
  } else {
    if (retryCount >= MAX_RETRY) {
      // 超过最大重试，触发重连
      reconnect(wsUrl)
      return
    }
    setTimeout(() => {
      sendWebSocket(retryCount + 1)
    }, 1000)
  }
}

/**
 * 初始化事件
 */
const init = () => {
  if (!webSocket) return

  webSocket.onclose = function (event) {
    heartCheck.stop()
    // wasClean=true 正常关闭，不需要重连；异常断开才重连
    if (!event.wasClean) {
      reconnect(wsUrl)
    }
  }

  webSocket.onerror = function () {
    console.log('ws发生异常')
    heartCheck.stop()
    reconnect(wsUrl)
  }

  webSocket.onopen = function () {
    sendWebSocket()
  }

  webSocket.onmessage = function (evt) {
    try {
      const data = JSON.parse(evt.data)
      // token失效，断开重连
      if (data.code === 41001) {
        closeSocket()
        reconnect(wsUrl)
        return
      }
      if (data.type < 10000) {
        data.data.type = data.type
        console.log('ws消息：', data)
        store.commit('UPDATENEWNOTIFY', data.data)
      }
      // 收到任意消息重置心跳计时
      heartCheck.start()
    } catch (err) {
      console.error('ws消息解析失败', err)
    }
  }
}

/**
 * 创建连接入口
 * @param {string} url ws地址
 */
const connectSocket = (url) => {
  wsUrl = url
  // ✅关键：已有实例先关闭旧连接，杜绝重复创建
  if (webSocket) {
    closeSocket()
  }

  try {
    webSocket = new WebSocket(url)
    init()
  } catch (e) {
    console.error('ws创建失败', e)
    reconnect(url)
  }
}

export default connectSocket
